import { FC } from "react";
import PageTemplate from "../PageTemplate";
import ApplicationsPage from "./ApplicationsPage";

const Applications: FC = () => {
    return <PageTemplate Page={ApplicationsPage} />;
};

export default Applications;
